export default __webpack_public_path__ + "static/media/calendar.dc10f5fa.svg";